// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"135":"235b85c7","187":"560df566","485":"553cba98","807":"c0feb621"}[chunkId] + ".chunk.css";
};